import { useQueryClient } from '@tanstack/react-query'
import { memo, useEffect, useRef } from 'react'
import { usePluginQueryKeysToInvalidateStore } from '@/lib/store'

export const InvalidatePlugin = memo(function InvalidatePlugin() {
  const queryClient = useQueryClient()
  const queryKeys = usePluginQueryKeysToInvalidateStore((state) => state.queryKeys)
  const removeQueryKeys = usePluginQueryKeysToInvalidateStore((state) => state.removeQueryKeys)

  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    if (!queryKeys.length) return

    if (timeoutRef.current) clearTimeout(timeoutRef.current)
    timeoutRef.current = setTimeout(async () => {
      timeoutRef.current = null
      const keys = usePluginQueryKeysToInvalidateStore.getState().queryKeys
      await Promise.all(keys.map((queryKey) => queryClient.invalidateQueries({ queryKey })))
      removeQueryKeys(keys)
    }, 300)

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
        timeoutRef.current = null
      }
    }
  }, [queryKeys, removeQueryKeys, queryClient])

  return null
})
